import _ from "underscore";

const linkre = /(<\s*a\s+[^>]*href\s*=\s*")([^"]+)"[^>]*>/gi;

export const typedescs = {
  '': 'Normal',
  'notrack': 'External Unsubscribe',
  'unsublink': 'Unsubscribe',
  'unsub': 'Unsubscribe',
};

export function decode(url) {
  url = url.replace(/&lt;/ig, '<');
  url = url.replace(/&gt;/ig, '>');
  url = url.replace(/&quot;/ig, '"');
  url = url.replace(/&apos;/ig, "'");
  url = url.replace(/&amp;/ig, '&');
  return url;
}


export function getLinkType(url, addprefix) {
  var type = '';
  if (url === '{{!!unsublink}}') {
    type = 'unsub';
    url = '';
  } else {
    var m = /^\{\{!!unsublink\|([^}]+)\}\}$/.exec(url);
    if (m) {
      type = 'unsublink';
      url = m[1];
    } else {
      m = /^\{\{!!notrack\|([^}]+)\}\}$/.exec(url);
      if (m) {
        type = 'notrack';
        url = m[1];
      } else if (addprefix && url && !/^[a-zA-Z]+:/.test(url)) {
        url = 'http://' + url;
      }
    }
  }
  return {link: url, type: type};
}

export function getHTML(obj) {
  var html = '';
  if (!obj.type) {
    _.each(obj.parts, p => {
      if (p.type !== 'Invisible') {
        html += p.html + '\n';
      }
    });
  } else if (obj.type === 'beefree') {
    html = JSON.parse(obj.rawText).html;
  } else {
    html = obj.rawText;
  }
  return html;
}

function pct(c, total) {
  if (total === 0) {
    return '0';
  } else {
    return Math.round(((c * 1.0) / total) * 100);
  }
}

export function popupCSS() {
  return `
  <style>
  .fade {
    opacity: 0;
    -webkit-transition: opacity .15s linear;
         -o-transition: opacity .15s linear;
            transition: opacity .15s linear;
  }
  .fade.in {
    opacity: 1;
  }
  .popover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1060;
    display: none;
    max-width: 276px;
    padding: 1px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    line-height: 1.42857143;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    white-space: normal;
    background-color: #fff;
    -webkit-background-clip: padding-box;
            background-clip: padding-box;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
            box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
  
    line-break: auto;
  }
  .popover.top {
    margin-top: -10px;
  }
  .popover.right {
    margin-left: 10px;
  }
  .popover.bottom {
    margin-top: 10px;
  }
  .popover.left {
    margin-left: -10px;
  }
  .popover-title {
    padding: 8px 14px;
    margin: 0;
    font-size: 14px;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    border-radius: 5px 5px 0 0;
  }
  .popover-content {
    padding: 9px 14px;
  }
  .popover > .arrow,
  .popover > .arrow:after {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .popover > .arrow {
    border-width: 11px;
  }
  .popover > .arrow:after {
    content: "";
    border-width: 10px;
  }
  .popover.top > .arrow {
    bottom: -11px;
    left: 50%;
    margin-left: -11px;
    border-top-color: #999;
    border-top-color: rgba(0, 0, 0, .25);
    border-bottom-width: 0;
  }
  .popover.top > .arrow:after {
    bottom: 1px;
    margin-left: -10px;
    content: " ";
    border-top-color: #fff;
    border-bottom-width: 0;
  }
  .popover.right > .arrow {
    top: 50%;
    left: -11px;
    margin-top: -11px;
    border-right-color: #999;
    border-right-color: rgba(0, 0, 0, .25);
    border-left-width: 0;
  }
  .popover.right > .arrow:after {
    bottom: -10px;
    left: 1px;
    content: " ";
    border-right-color: #fff;
    border-left-width: 0;
  }
  .popover.bottom > .arrow {
    top: -11px;
    left: 50%;
    margin-left: -11px;
    border-top-width: 0;
    border-bottom-color: #999;
    border-bottom-color: rgba(0, 0, 0, .25);
  }
  .popover.bottom > .arrow:after {
    top: 1px;
    margin-left: -10px;
    content: " ";
    border-top-width: 0;
    border-bottom-color: #fff;
  }
  .popover.left > .arrow {
    top: 50%;
    right: -11px;
    margin-top: -11px;
    border-right-width: 0;
    border-left-color: #999;
    border-left-color: rgba(0, 0, 0, .25);
  }
  .popover.left > .arrow:after {
    right: 1px;
    bottom: -10px;
    content: " ";
    border-right-width: 0;
    border-left-color: #fff;
  }
  .popover.black-popover {
    background-color: black;
    color: white;
    white-space: nowrap;
  }
  
  .popover.top.black-popover>.arrow:after {
    border-top-color: black;
  }
  </style>
  `;
}

export function insertPopups(obj) {
  var html = getHTML(obj);

  var linkclicks = obj.linkclicks;
  if (!linkclicks) {
    linkclicks = [];
  }

  getLinks(obj).forEach((v, i) => {
    if (linkclicks.length <= i) {
      linkclicks.push(0);
    }
  });

  var index = 0;

  var total = 0;
  _.each(obj.linkclicks, cnt => { total += cnt });

  html = html.replace(/<p /ig, '<div ');
  html = html.replace(/<p>/ig, '<div>');
  html = html.replace(/<\/p>/ig, '</div>');

  return html.replace(linkre, m => {
    var randpct = (Math.random() * 100).toFixed();
    var r = m + `
      <div style="position:relative">
        <div class="popover black-popover fade top in" id="popover-${index}" style="display: block; top: -44px; left: calc(${randpct}% - 28px)">
          <div class="arrow" style="left: 50%"></div>
          <div class="popover-content">
            ${pct(linkclicks[index], total)}% (${linkclicks[index].toLocaleString()})
          </div>
        </div>
      </div>
`
    index++;
    return r;
  });
}

export function getLinks(obj) {
  var html = getHTML(obj);

  var ret = [];

  var m = linkre.exec(html);
  while (m) {
    var link = m[2];

    ret.push(getLinkType(link, true));

    m = linkre.exec(html);
  }

  return ret;
}

export function routesHelp(routes) {
  if (routes && routes.length === 1 && routes[0].name.toLowerCase().trim() === 'drop all mail') {
    return 'Add additional postal routes to enable sending mail';
  }
  return undefined;
}


// WEBPACK FOOTER //
// ./src/utils/template-utils.js